interface IButtonProps {
  type?: 'button' | 'submit' | 'reset'
  size: 'xl' | 'lg' | 'md' | 'sm'
  disabled?: boolean
  customEvent?: () => void
  theme: 'primary' | 'secondary' | 'assistive'
  rightIcon?: React.ReactNode
  leftIcon?: React.ReactNode
  text: string
  width?: string | number
  className?: string
}

interface IStyle {
  [key: string]: string
}

const Button = (props: IButtonProps) => {
  const {
    type = 'button',
    size,
    text,
    theme,
    disabled = false,
    customEvent,
    leftIcon,
    rightIcon,
    width = 'full',
    className = '',
  } = props

  const themeStyle: IStyle = {
    primary: 'bg-primary-normal text-white disabled:opacity-[0.1]',
    secondary:
      'border border-primary-normal text-primary-normal disabled:border-neutral-200 disabled:text-gray-disable',
    assistive:
      'border border-line-normal text-gray-normal disabled:border-neutral-200 disabled:text-gray-disable',
  }

  const sizeStyle: IStyle = {
    xl: 'py-2.5 px-4 rounded-lg text-base font-semibold',
    lg: 'py-2.5 px-4 rounded-lg text-base font-semibold',
    md: 'py-1.5 px-3 rounded-md text-sm font-semibold',
    sm: 'py-1.5 px-2 rounded-md text-sm font-semibold',
  }

  const disabledStyle = disabled ? 'cursor-default' : 'cursor-pointer'

  return (
    <button
      type={type}
      className={`${themeStyle[theme]} ${sizeStyle[size]} inline-flex w-${width} flex items-center justify-center gap-1 ${disabledStyle} ${className}`}
      onClick={customEvent}
      disabled={disabled}
    >
      {leftIcon && leftIcon}
      {text}
      {rightIcon && rightIcon}
    </button>
  )
}

export default Button
